import { renderRoutes } from 'react-router-config';

import Home from './app/Home';
import CardAnnouncement from './app/CardAnnouncement';
import Search from './app/Search';
import Favorites from './app/Favorites';
import Tariffs from './app/Tariffs';
import SavedSearch from './app/SavedSearch';
import NotFoundError from './ui/Pages/Errors/404';
import { getHomeUrl, getCardUrl, getSearchUrl } from './utils/urls';
import { SALE, RENT, RENTDAILY, APARTMENTS, LANDS, COMMERCIALS, GARAGES } from './consts';
import {
  SALE_APARTMENTS_NEWBUILDING,
  SALE_APARTMENTS_1_ROOM, SALE_APARTMENTS_2_ROOM, SALE_APARTMENTS_3_ROOM, SALE_APARTMENTS_4_ROOM, SALE_APARTMENTS_5_ROOM,
  SALE_APARTMENTS_ROOMS, SALE_APARTMENTS_PART,
  SALE_APARTMENTS_1_ROOM_NEW, SALE_APARTMENTS_2_ROOM_NEW, SALE_APARTMENTS_3_ROOM_NEW, SALE_APARTMENTS_4_ROOM_NEW,
  SALE_APARTMENTS_5_ROOM_NEW, SALE_APARTMENTS_ROOMS_NEW, SALE_APARTMENTS_PART_NEW,
  SALE_APARTMENTS_KIROVSKIJ, SALE_APARTMENTS_LENINSKIJ, SALE_APARTMENTS_OKTYABRSKIJ, SALE_APARTMENTS_SOVETSKIJ,
  SALE_APARTMENTS_CENTRALNYJ, SALE_APARTMENTS_CENTR, SALE_APARTMENTS_OBLAST,

  RENT_APARTMENTS_1_ROOM, RENT_APARTMENTS_2_ROOM, RENT_APARTMENTS_3_ROOM, RENT_APARTMENTS_4_ROOM, RENT_APARTMENTS_5_ROOM,
  RENT_APARTMENTS_ROOMS, RENT_APARTMENTS_HOUSE, RENT_APARTMENTS_HOUSE_COTTAGE, RENT_APARTMENTS_COTTAGE, RENT_APARTMENTS_TOWNHOUSE,
  RENT_APARTMENTS_KIROVSKIJ, RENT_APARTMENTS_LENINSKIJ, RENT_APARTMENTS_OKTYABRSKIJ, RENT_APARTMENTS_SOVETSKIJ,
  RENT_APARTMENTS_CENTRALNYJ, RENT_APARTMENTS_CENTR, RENT_APARTMENTS_OBLAST,

  RENTDAILY_1_ROOM, RENTDAILY_2_ROOM, RENTDAILY_3_ROOM, RENTDAILY_4_ROOM, RENTDAILY_HOUSE, RENTDAILY_COTTAGE,
  RENTDAILY_TOWNHOUSE, RENTDAILY_HOSTEL,
  RENTDAILY_KIROVSKIJ, RENTDAILY_LENINSKIJ, RENTDAILY_OKTYABRSKIJ, RENTDAILY_SOVETSKIJ, RENTDAILY_CENTRALNYJ,
  RENTDAILY_CENTR, RENTDAILY_OBLAST,

  SALE_LAND_HOUSE, SALE_LAND_COTTAGE, SALE_LAND_TOWNHOUSE, SALE_LAND_LANDS, SALE_LAND_DACHA,
  SALE_LAND_KIROVSKIJ, SALE_LAND_LENINSKIJ, SALE_LAND_OKTYABRSKIJ, SALE_LAND_SOVETSKIJ,
  SALE_LAND_CENTRALNYJ, SALE_LAND_CENTR, SALE_LAND_OBLAST,

  GARAGES_CAPITAL, GARAGES_CONCRETE, GARAGES_METAL, GARAGES_PLACE, GARAGES_TODAY, GARAGES_WEEK,
  GARAGES_KIROVSKIJ, GARAGES_LENINSKIJ, GARAGES_OKTYABRSKIJ, GARAGES_SOVETSKIJ, GARAGES_CENTRALNYJ,
  GARAGES_CENTR, GARAGES_OBLAST,

  SALE_COMMERCIALS_OFFICE, SALE_COMMERCIALS_SHELF_SPACE, SALE_COMMERCIALS_WAREHOUSE, SALE_COMMERCIALS_CATERING,
  SALE_COMMERCIALS_SERVICE_STATION, SALE_COMMERCIALS_BUSINESS, SALE_COMMERCIALS_FREE, SALE_COMMERCIALS_OWNER,
  SALE_COMMERCIALS_ONE_FLOOR,
  SALE_COMMERCIALS_KIROVSKIJ, SALE_COMMERCIALS_LENINSKIJ, SALE_COMMERCIALS_OKTYABRSKIJ, SALE_COMMERCIALS_SOVETSKIJ,
  SALE_COMMERCIALS_CENTRALNYJ, SALE_COMMERCIALS_CENTR, SALE_COMMERCIALS_OBLAST,

  RENT_COMMERCIALS_OFFICE, RENT_COMMERCIALS_SHELF_SPACE, RENT_COMMERCIALS_WAREHOUSE, RENT_COMMERCIALS_CATERING,
  RENT_COMMERCIALS_SERVICE_STATION, RENT_COMMERCIALS_BUSINESS, RENT_COMMERCIALS_FREE, RENT_COMMERCIALS_OWNER,
  RENT_COMMERCIALS_ONE_FLOOR,
  RENT_COMMERCIALS_KIROVSKIJ, RENT_COMMERCIALS_LENINSKIJ, RENT_COMMERCIALS_OKTYABRSKIJ, RENT_COMMERCIALS_SOVETSKIJ,
  RENT_COMMERCIALS_CENTRALNYJ, RENT_COMMERCIALS_CENTR, RENT_COMMERCIALS_OBLAST
} from './utils/aliases';

export const routeConfig = [
  // главные страницы
  {
    path: getHomeUrl(SALE, APARTMENTS),
    exact: true,
    component: Home.SaleApartments
  }, {
    path: getHomeUrl(SALE, COMMERCIALS),
    component: Home.SaleCommercials
  }, {
    path: getHomeUrl(SALE, LANDS),
    component: Home.SaleLands
  }, {
    path: getHomeUrl(SALE, GARAGES),
    component: Home.SaleGarages
  },

  {
    path: getHomeUrl(RENT, APARTMENTS),
    component: Home.RentApartments
  },
  {
    path: getHomeUrl(RENTDAILY, APARTMENTS),
    component: Home.RentDailyApartments
  },
  {
    path: getHomeUrl(RENT, COMMERCIALS),
    component: Home.RentCommercials
  },

  {
    path: '/select_city',
    component: Home
  },
  {
    path: '/favorites/:dealType?/:realtyType?/:page(\\d+)?/',
    component: Favorites
  },
  {
    path: '/tariffs',
    component: Tariffs
  },
  {
    path: '/saved-searches/:dealType?/:realtyType?/:page(\\d+)?/',
    component: SavedSearch
  },

  // карточки
  {
    path: getCardUrl(SALE, APARTMENTS),
    component: CardAnnouncement.SaleApartments
  }, {
    path: getCardUrl(SALE, COMMERCIALS),
    component: CardAnnouncement.SaleCommercials
  }, {
    path: getCardUrl(SALE, LANDS),
    component: CardAnnouncement.SaleLands
  }, {
    path: getCardUrl(SALE, GARAGES),
    component: CardAnnouncement.SaleGarages
  }, {
    path: getCardUrl(RENT, APARTMENTS),
    component: CardAnnouncement.RentApartments
  }, {
    path: getCardUrl(RENTDAILY, APARTMENTS),
    component: CardAnnouncement.RentDailyApartments
  }, {
    path: getCardUrl(RENT, COMMERCIALS),
    component: CardAnnouncement.RentCommercials
  },

  // листинги
  {
    path: [
      // листинг главная - продажа жилой
      getSearchUrl(SALE, APARTMENTS),
      // альясы
      SALE_APARTMENTS_NEWBUILDING,
      SALE_APARTMENTS_1_ROOM,
      SALE_APARTMENTS_2_ROOM,
      SALE_APARTMENTS_3_ROOM,
      SALE_APARTMENTS_4_ROOM,
      SALE_APARTMENTS_5_ROOM,
      SALE_APARTMENTS_ROOMS,
      SALE_APARTMENTS_PART,
      // новостройки
      SALE_APARTMENTS_1_ROOM_NEW,
      SALE_APARTMENTS_2_ROOM_NEW,
      SALE_APARTMENTS_3_ROOM_NEW,
      SALE_APARTMENTS_4_ROOM_NEW,
      SALE_APARTMENTS_5_ROOM_NEW,
      SALE_APARTMENTS_ROOMS_NEW,
      SALE_APARTMENTS_PART_NEW,
      // районы
      SALE_APARTMENTS_KIROVSKIJ,
      SALE_APARTMENTS_LENINSKIJ,
      SALE_APARTMENTS_OKTYABRSKIJ,
      SALE_APARTMENTS_SOVETSKIJ,
      SALE_APARTMENTS_CENTRALNYJ,
      SALE_APARTMENTS_CENTR,
      SALE_APARTMENTS_OBLAST
    ],
    component: Search.SaleApartments
  }, {
    path: [
      // листинг главная - продажа коммерческой
      getSearchUrl(SALE, COMMERCIALS),
      // альясы
      SALE_COMMERCIALS_OFFICE,
      SALE_COMMERCIALS_SHELF_SPACE,
      SALE_COMMERCIALS_WAREHOUSE,
      SALE_COMMERCIALS_CATERING,
      SALE_COMMERCIALS_SERVICE_STATION,
      SALE_COMMERCIALS_BUSINESS,
      SALE_COMMERCIALS_FREE,
      SALE_COMMERCIALS_ONE_FLOOR,
      SALE_COMMERCIALS_OWNER,
      // районы
      SALE_COMMERCIALS_KIROVSKIJ,
      SALE_COMMERCIALS_LENINSKIJ,
      SALE_COMMERCIALS_OKTYABRSKIJ,
      SALE_COMMERCIALS_SOVETSKIJ,
      SALE_COMMERCIALS_CENTRALNYJ,
      SALE_COMMERCIALS_CENTR,
      SALE_COMMERCIALS_OBLAST
    ],
    component: Search.SaleCommercials
  }, {
    path: [
      // листинг главная - продажа земли
      getSearchUrl(SALE, LANDS),
      // альясы
      SALE_LAND_HOUSE,
      SALE_LAND_COTTAGE,
      SALE_LAND_TOWNHOUSE,
      SALE_LAND_DACHA,
      SALE_LAND_LANDS,
      // районы
      SALE_LAND_KIROVSKIJ,
      SALE_LAND_LENINSKIJ,
      SALE_LAND_OKTYABRSKIJ,
      SALE_LAND_SOVETSKIJ,
      SALE_LAND_CENTRALNYJ,
      SALE_LAND_CENTR,
      SALE_LAND_OBLAST
    ],
    component: Search.SaleLands
  }, {
    path: [
      // листинг главная - продажа гаражи
      getSearchUrl(SALE, GARAGES),
      // альясы
      GARAGES_CAPITAL,
      GARAGES_CONCRETE,
      GARAGES_METAL,
      GARAGES_PLACE,
      GARAGES_TODAY,
      GARAGES_WEEK,
      // районы
      GARAGES_KIROVSKIJ,
      GARAGES_LENINSKIJ,
      GARAGES_OKTYABRSKIJ,
      GARAGES_SOVETSKIJ,
      GARAGES_CENTRALNYJ,
      GARAGES_CENTR,
      GARAGES_OBLAST
    ],
    component: Search.SaleGarages
  }, {
    path: [
      // листинг главная - длительная аренда жилой
      getSearchUrl(RENT, APARTMENTS),
      // альясы
      RENT_APARTMENTS_1_ROOM,
      RENT_APARTMENTS_2_ROOM,
      RENT_APARTMENTS_3_ROOM,
      RENT_APARTMENTS_4_ROOM,
      RENT_APARTMENTS_5_ROOM,
      RENT_APARTMENTS_ROOMS,
      RENT_APARTMENTS_HOUSE,
      RENT_APARTMENTS_HOUSE_COTTAGE,
      RENT_APARTMENTS_COTTAGE,
      RENT_APARTMENTS_TOWNHOUSE,
      // районы
      RENT_APARTMENTS_KIROVSKIJ,
      RENT_APARTMENTS_LENINSKIJ,
      RENT_APARTMENTS_LENINSKIJ,
      RENT_APARTMENTS_OKTYABRSKIJ,
      RENT_APARTMENTS_SOVETSKIJ,
      RENT_APARTMENTS_CENTRALNYJ,
      RENT_APARTMENTS_CENTR,
      RENT_APARTMENTS_OBLAST
    ],
    component: Search.RentApartments
  }, {
    path: [
      // листинг главная - посуточная аренда жилой
      getSearchUrl(RENTDAILY, APARTMENTS),
      // альясы
      RENTDAILY_1_ROOM,
      RENTDAILY_2_ROOM,
      RENTDAILY_3_ROOM,
      RENTDAILY_4_ROOM,
      RENTDAILY_HOUSE,
      RENTDAILY_COTTAGE,
      RENTDAILY_TOWNHOUSE,
      RENTDAILY_HOSTEL,
      // районы
      RENTDAILY_KIROVSKIJ,
      RENTDAILY_LENINSKIJ,
      RENTDAILY_OKTYABRSKIJ,
      RENTDAILY_SOVETSKIJ,
      RENTDAILY_CENTRALNYJ,
      RENTDAILY_CENTR,
      RENTDAILY_OBLAST
    ],
    component: Search.RentDailyApartments
  }, {
    path: [
      // листинг главная - аренда коммерческая
      getSearchUrl(RENT, COMMERCIALS),
      // альясы
      RENT_COMMERCIALS_OFFICE,
      RENT_COMMERCIALS_SHELF_SPACE,
      RENT_COMMERCIALS_WAREHOUSE,
      RENT_COMMERCIALS_CATERING,
      RENT_COMMERCIALS_SERVICE_STATION,
      RENT_COMMERCIALS_BUSINESS,
      RENT_COMMERCIALS_FREE,
      RENT_COMMERCIALS_ONE_FLOOR,
      RENT_COMMERCIALS_OWNER,
      // районы
      RENT_COMMERCIALS_KIROVSKIJ,
      RENT_COMMERCIALS_LENINSKIJ,
      RENT_COMMERCIALS_OKTYABRSKIJ,
      RENT_COMMERCIALS_SOVETSKIJ,
      RENT_COMMERCIALS_CENTRALNYJ,
      RENT_COMMERCIALS_CENTR,
      RENT_COMMERCIALS_OBLAST
    ],
    component: Search.RentCommercials
  },

  { path: '*', component: NotFoundError }
];

export default renderRoutes(routeConfig);



// WEBPACK FOOTER //
// ./src/routes.jsx